module.exports = __webpack_public_path__ + "media/CN_011.3fbd3e0b.mp3";